<template>
    <div>
        <div
            class="d-flex slot-block"
            :class="{
                'active': isExpanded,
                'overlap-error': overlap,
                'unavailable': !isAvailable,
                'not-editable': !canEdit
              }"
            @click="canEdit && isAvailable ? toggleExpand() : (bookedUserInfo ? handleModalClick() : null)"
            style="cursor: pointer;"
        >
            <div class="time-info">
                <p>{{ formatTime(timeRange.start_time) }}</p>
                <p>{{ formatTime(timeRange.end_time) }}</p>
            </div>

            <div class="time-block appointment-block">
                <span class="block-label">
                    {{ appointmentInterviewLabel }} ({{ duration }} min)
                    <small v-if="!isAvailable" class="text-muted ml-2">
                        {{ appointmentBookedLabel }}
                        <template v-if="bookedUserInfo">
                            <a :href="bookedUserInfo.profile_url" target="_blank" :class="{'text-orange': bookedUserInfo.status === 'required_attention'}">
                                {{ bookedUserInfo.user.firstname }} {{ bookedUserInfo.user.lastname }}
                            </a>
                        </template>
                    </small>
                </span>
            </div>

            <div class="delete-action ml-auto">
                <button
                    v-if="canEdit"
                    class="delete-btn"
                    @click.stop="deleteRequest"
                    title="Supprimer ce rendez-vous"
                    :disabled="!isAvailable || !canEdit"
                    :class="{'disabled': !isAvailable || !canEdit}"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" viewBox="0 0 14 14" fill="none">
                        <path d="M9.35375 5.35375L7.70688 7L9.35375 8.64625C9.40021 8.69271 9.43706 8.74786 9.4622 8.80855C9.48734 8.86925 9.50028 8.9343 9.50028 9C9.50028 9.0657 9.48734 9.13075 9.4622 9.19145C9.43706 9.25214 9.40021 9.30729 9.35375 9.35375C9.3073 9.40021 9.25215 9.43705 9.19145 9.4622C9.13075 9.48734 9.0657 9.50028 9 9.50028C8.93431 9.50028 8.86925 9.48734 8.80855 9.4622C8.74786 9.43705 8.69271 9.40021 8.64625 9.35375L7 7.70687L5.35375 9.35375C5.3073 9.40021 5.25215 9.43705 5.19145 9.4622C5.13075 9.48734 5.0657 9.50028 5 9.50028C4.93431 9.50028 4.86925 9.48734 4.80855 9.4622C4.74786 9.43705 4.69271 9.40021 4.64625 9.35375C4.5998 9.30729 4.56295 9.25214 4.53781 9.19145C4.51266 9.13075 4.49972 9.0657 4.49972 9C4.49972 8.9343 4.51266 8.86925 4.53781 8.80855C4.56295 8.74786 4.5998 8.69271 4.64625 8.64625L6.29313 7L4.64625 5.35375C4.55243 5.25993 4.49972 5.13268 4.49972 5C4.49972 4.86732 4.55243 4.74007 4.64625 4.64625C4.74007 4.55243 4.86732 4.49972 5 4.49972C5.13268 4.49972 5.25993 4.55243 5.35375 4.64625L7 6.29313L8.64625 4.64625C8.69271 4.59979 8.74786 4.56294 8.80855 4.5378C8.86925 4.51266 8.93431 4.49972 9 4.49972C9.0657 4.49972 9.13075 4.51266 9.19145 4.5378C9.25215 4.56294 9.3073 4.59979 9.35375 4.64625C9.40021 4.6927 9.43706 4.74786 9.4622 4.80855C9.48734 4.86925 9.50028 4.9343 9.50028 5C9.50028 5.0657 9.48734 5.13075 9.4622 5.19145C9.43706 5.25214 9.40021 5.3073 9.35375 5.35375ZM13.5 7C13.5 8.28558 13.1188 9.54229 12.4046 10.6112C11.6903 11.6801 10.6752 12.5132 9.48744 13.0052C8.29973 13.4972 6.99279 13.6259 5.73192 13.3751C4.47104 13.1243 3.31285 12.5052 2.40381 11.5962C1.49477 10.6872 0.875703 9.52896 0.624899 8.26809C0.374095 7.00721 0.502816 5.70028 0.994786 4.51256C1.48676 3.32484 2.31988 2.30968 3.3888 1.59545C4.45772 0.881218 5.71442 0.5 7 0.5C8.72335 0.50182 10.3756 1.18722 11.5942 2.40582C12.8128 3.62441 13.4982 5.27665 13.5 7ZM12.5 7C12.5 5.9122 12.1774 4.84883 11.5731 3.94436C10.9687 3.03989 10.1098 2.33494 9.10476 1.91866C8.09977 1.50238 6.9939 1.39346 5.92701 1.60568C4.86011 1.8179 3.8801 2.34172 3.11092 3.11091C2.34173 3.8801 1.8179 4.86011 1.60568 5.927C1.39347 6.9939 1.50238 8.09977 1.91867 9.10476C2.33495 10.1098 3.0399 10.9687 3.94437 11.5731C4.84884 12.1774 5.91221 12.5 7 12.5C8.45819 12.4983 9.85617 11.9184 10.8873 10.8873C11.9184 9.85617 12.4983 8.45818 12.5 7Z" fill="#C73466"/>
                    </svg>
                </button>

                <button v-if="bookedUserInfo" class="delete-btn" @click.stop="handleModalClick">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 20 20">
                        <path d="M14.846 2.954a2.25 2.25 0 0 1 3.182 3.182l-1.06 1.06-3.182-3.182 1.06-1.06Zm-2.12 2.12-9.192 9.192a2 2 0 0 0-.512.878l-1.01 3.03a.5.5 0 0 0 .632.632l3.03-1.01a2 2 0 0 0 .878-.512l9.192-9.192-3.182-3.182Z" fill="#888"/>
                    </svg>
                </button>
            </div>
        </div>

        <!-- Collapsible input fields -->
        <div v-if="isExpanded && isAvailable && canEdit" class="appointment-inputs mt-2 mb-3 pl-4">
            <div class="d-flex">
                <div class="form-group col-md-6">
                    <label for="start-time">{{ appointmentStartTimeLabel }}</label>
                    <input
                        type="time"
                        class="form-control form-control-sm"
                        id="start-time"
                        v-model="localStartTime"
                        @change="updateTimes"
                    >
                </div>
                <div class="form-group col-md-6">
                    <label for="end-time">{{ appointmentEndTimeLabel }}</label>
                    <input
                        type="time"
                        class="form-control form-control-sm"
                        id="end-time"
                        v-model="localEndTime"
                        @change="updateTimes"
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import timeMixin from "../../Mixins/appointmentsMixin";

export default {
    name: "AppointmentBlock",
    mixins: [timeMixin],
    props: {
        timeRange: {
            type: Object,
            required: true
        },
        isExpanded: {
            type: Boolean,
            default: false
        },
        overlap: {
            type: Boolean,
            default: false
        },
        canEdit: {
            type: Boolean,
            default: false
        },
        appointmentInterviewLabel: String,
        appointmentBookedLabel: String,
        appointmentStartTimeLabel: String,
        appointmentEndTimeLabel: String,
        bookedAppointments: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            localStartTime: this.timeRange.start_time,
            localEndTime: this.timeRange.end_time
        };
    },
    computed: {
        duration() {
            return this.calculateDuration(this.timeRange.start_time, this.timeRange.end_time);
        },
        isAvailable() {
            return this.timeRange.available;
        },
        bookedUserInfo() {
            if (!this.isAvailable && this.bookedAppointments && this.bookedAppointments.length > 0) {
                const foundAppointment = this.bookedAppointments.find(appt => {
                    if (!appt.dateTime || !appt.user) return false;

                    const apptDate = new Date(appt.dateTime);

                    const apptYear = apptDate.getUTCFullYear();
                    const apptMonth = String(apptDate.getUTCMonth() + 1).padStart(2, '0');
                    const apptDay = String(apptDate.getUTCDate()).padStart(2, '0');
                    const formattedApptDate = `${apptYear}-${apptMonth}-${apptDay}`;

                    const apptHours = String(apptDate.getUTCHours()).padStart(2, '0');
                    const apptMinutes = String(apptDate.getUTCMinutes()).padStart(2, '0');
                    const formattedApptTime = `${apptHours}:${apptMinutes}`;

                    return formattedApptDate === this.timeRange.day && formattedApptTime === this.formatTime(this.timeRange.start_time);
                });

                if (foundAppointment) {
                    return foundAppointment;
                }
            }
            return null;
        }
    },
    watch: {
        'timeRange.start_time'(newValue) {
            this.localStartTime = newValue;
        },
        'timeRange.end_time'(newValue) {
            this.localEndTime = newValue;
        }
    },
    methods: {
        toggleExpand() {
            if (this.isAvailable && this.canEdit) {
                this.$emit('toggle-expand');
            }
        },
        deleteRequest() {
            if (this.isAvailable && this.canEdit) {
                this.$emit('delete-request', this.timeRange);
            }
        },
        updateTimes() {
            if (this.isAvailable && this.canEdit) {
                this.$emit('update-times', {
                    ...this.timeRange,
                    start_time: this.localStartTime,
                    end_time: this.localEndTime
                });
            }
        },
        toggleAModal(ref) {
            if (window.vm && typeof window.vm.toggleAModal === 'function') {
                window.vm.toggleAModal(ref);
            }
        },
        handleModalClick() {
            if (window.vm && this.bookedUserInfo) {
                window.vm.cvlib.toBook = this.bookedUserInfo.invitation;
                this.toggleAModal('modal__choose_a_date');
            }
        }
    }
}
</script>

